import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { BrandsService } from '../services/brands.service';
import { AuthService } from '../services/auth.service';
import { BrandAccessibility } from '../shared/brands.model';
import { LanguageService } from '../services/language.service';

@Injectable({
  providedIn: 'root'
})
export class BrandPageGuard implements CanActivate {

  brandsData: BrandAccessibility[];

  constructor(
    private authService: AuthService,
    private brandsService: BrandsService,
    private router: Router,
    private languageService: LanguageService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      if (!this.brandsData) {
        this.brandsService.getBrandsAccessibility().subscribe((brands: BrandAccessibility[]) => {
          this.brandsData = brands;
          const matchingBrand = this.getMatchingBrand(this.brandsData, route.params.slug);
          if (matchingBrand.accessible) {
            resolve(true);
          } else {
            this.authService.getCurrentUser().subscribe(
              (user) => {
                const allowedPledgeId = matchingBrand?.pledge_ids?.find((id) => user?.pledge_id === id);
                if (allowedPledgeId) {
                  resolve(true);
                } else {
                  this.onUserIsNotAllowed();
                }
              }, (err) => {
                this.onUserIsNotAllowed();
              });
          }
        });
      } else {
        const matchingBrand = this.getMatchingBrand(this.brandsData, route.params.slug);
        if (matchingBrand.accessible) {
          resolve(true);
        } else {
          this.authService.getCurrentUser().subscribe(
            (user) => {
              const allowedPledgeId = matchingBrand?.pledge_ids?.find((id) => user?.pledge_id === id);
              if (allowedPledgeId) {
                resolve(true);
              } else {
                this.onUserIsNotAllowed();
              }
            }, (err) => {
              this.onUserIsNotAllowed();
            });
        }
      }
    });
  }

  onUserIsNotAllowed(): void {
    this.router.navigate([this.languageService.getCurrentLangWithSlash()]);
  }

  getMatchingBrand(brands: BrandAccessibility[], brandSlug: string): BrandAccessibility {
    let selectedBrand = brands?.find((brand) => brandSlug === brand?.slug);
    // In case is not found, we check for aliases
    if (!selectedBrand) {
      brands.forEach((brand) => {
        const matchedAlias = brand.alias.find((alias) => brandSlug === alias);
        if (matchedAlias) {
          selectedBrand = brand;
        }
      });
    }
    return selectedBrand;
  }
}
